import * as React from 'react';
import Cell from '../Cell';
import TableContext from '../context/TableContext';
import { getCellFixedInfo } from '../utils/fixUtil';
import { getColumnsKey } from '../utils/valueUtil';
function HeaderRow({ cells, stickyOffsets, flattenColumns, rowComponent: RowComponent, cellComponent: CellComponent, onHeaderRow, index }) {
    const { prefixCls, direction } = React.useContext(TableContext);
    let rowProps;
    if (onHeaderRow) {
        rowProps = onHeaderRow(cells.map(cell => cell.column), index);
    }
    const columnsKey = getColumnsKey(cells.map(cell => cell.column));
    return (<RowComponent {...rowProps}>
            {cells.map((cell, cellIndex) => {
            const { column } = cell;
            const fixedInfo = getCellFixedInfo(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
            let additionalProps;
            if (column && column.onHeaderCell) {
                additionalProps = cell.column.onHeaderCell(column);
            }
            return (<Cell {...cell} ellipsis={column.ellipsis} align={column.align} component={CellComponent} prefixCls={prefixCls} key={columnsKey[cellIndex]} {...fixedInfo} additionalProps={additionalProps} rowType="header"/>);
        })}
        </RowComponent>);
}
HeaderRow.displayName = 'HeaderRow';
export default HeaderRow;
